/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, DestroyRef, Input, OnInit, inject} from '@angular/core';
import template from './blocklist-list-page.component.html';

import {
  SignalAdminListColumn,
  SignalAdminResourceListStateFactory
} from '../common/controller/signal-admin-resource-list-state';
import {BlocklistApiService, BlocklistModel} from './blocklist-api.service';
import {UIRouterModule} from '@uirouter/angular';
import {AppSharedModule} from '../common/app-shared.module';
import {SignalAdminResourceListComponent} from '../common/controller/signal-admin-resource-list.component';

@Component({
  standalone: true,
  imports: [AppSharedModule, UIRouterModule, SignalAdminResourceListComponent],
  selector: 'adn-blocklist-list-page',
  template
})
export class BlocklistListPageComponent implements OnInit {
  readonly itemStateName = 'app.inv.blocklists.blocklist';

  readonly columns: SignalAdminListColumn[] = [
    {param: 'name'},
    {param: 'description'}
  ];
  readonly list = inject(SignalAdminResourceListStateFactory).create<BlocklistModel>(
    inject(BlocklistApiService),
    {listId: 'fullBlocklistList'},
    inject(DestroyRef)
  );

  @Input()
  set readOnly(value: boolean) {
    this.list.readOnly.set(value);
  }

  ngOnInit(): void {
    this.list.load();
  }
}
